import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import OcrReaderLogo from 'assets/images/logoSl.svg'

export default function Error() {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      sx={{
        backgroundColor: 'grey.200',
        height: '100%',
      }}
    >
      <img style={{ margin: '16px auto' }} width="220px" src={OcrReaderLogo} alt="logo" />
      <Typography variant="h6" style={{ color: 'red' }}>
        許可されたIPアドレスからアクセスしてください
      </Typography>
      <p>詳しくはシステム管理者にお問い合せください</p>
    </Stack>
  )
}
